import React from 'react';
import { ItemContext } from './shared.js';
import classes from './ActionList.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';
import Truncate from '../Truncate/Truncate.js';

const Description = ({
  variant = 'inline',
  sx = defaultSxProp,
  className,
  truncate,
  ...props
}) => {
  const {
    blockDescriptionId,
    inlineDescriptionId
  } = React.useContext(ItemContext);
  if (variant === 'block' || !truncate) {
    return /*#__PURE__*/jsx(BoxWithFallback, {
      as: "span",
      sx: sx,
      id: variant === 'block' ? blockDescriptionId : inlineDescriptionId,
      className: clsx(className, classes.Description),
      "data-component": "ActionList.Description",
      children: props.children
    });
  } else {
    return /*#__PURE__*/jsx(Truncate, {
      id: inlineDescriptionId,
      className: clsx(className, classes.Description),
      sx: sx,
      title: props.children,
      inline: true,
      maxWidth: "100%",
      "data-component": "ActionList.Description",
      children: props.children
    });
  }
};

export { Description };
